import type { AcuityClientInterface } from './acuityClient.types';
import CorporateAcuityClient from './corporateAcuityClient';
import type { ClientContext } from '~/services/contextClient';

export default class AcuityClientFactory {
    static createClient(context: Omit<ClientContext, 'groupId'>): AcuityClientInterface {
        return new CorporateAcuityClient(context.teamId);
    }
}
